import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Kanban, List } from "lucide-react";
import { useTheme } from "@/layout/ThemeProvider";
import InvoiceList from "./List";
import InvoiceKanban from "./InvoiceKanban";

const Invoice = () => {
  return (
    <div>
      <Tabs className="p-5" defaultValue="list">
        <TabsList>
          <TabsTrigger value="list" className="cursor-pointer px-5">
            <List />
          </TabsTrigger>
          <TabsTrigger value="kanban" className="cursor-pointer px-5">
            <Kanban />
          </TabsTrigger>
        </TabsList>
        <TabsContent value="list">
            <InvoiceList />
        </TabsContent>
        <TabsContent className="relative" value="kanban">
            <InvoiceKanban />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Invoice;
